const ftueEnum = {
    INTRO: 1,
    CONGRATS: 2,
};

Object.freeze(ftueEnum);

export default ftueEnum;
